import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import _ from '../../utils/LodashImports';
import { noop } from '../../utils/noop';
import { trackWarrantySelection } from '../Cart/Cart.Utils';
import Button from '../ui/Button/Button';
import Drawer from '../ui/Drawer/Drawer';
import { Modal } from '../ui/Modal/Modal';
import WarrantySelectEnhanced from '../ui/WarrantySelect/WarrantySelectEnhanced';
import WarrantyModalStyles from './WarrantyModal.style';

const WarrantyModal = ({
  appCtx,
  options,
  showModal,
  setShowModal,
  warrantyOptionCurrent,
  handleWarrantyChange,
  product,
  isExtendedWarranty = false,
}) => {
  const {
    CANCEL = 'Cancelar',
    ACCEPT_MKP = 'Aceptar',
    WITHOUT_EXTENDED_WARRANTY = 'Continuar sin protección',
    EXTENDED_WARRANTY_TITLE = 'Protege tu producto',
  } = _.get(appCtx, 'siteConfig.textDictionary', {});

  const [warrantyOption, setWarrantyOption] = useState(warrantyOptionCurrent);
  const { deviceType } = appCtx;
  const isDesktop = deviceType === 'desktop';

  useEffect(() => {
    if (showModal && options && options.length > 0) {
      let selectedOption;

      if (isExtendedWarranty) {
        const validOptions = options.filter((option) => option.offeringId || option.value);

        if (validOptions.length >= 2) {
          selectedOption = { ...validOptions[1], selected: true };
        } else if (validOptions.length === 1) {
          selectedOption = { ...validOptions[0], selected: true };
        }
      } else if (warrantyOptionCurrent) {
        selectedOption = warrantyOptionCurrent;
      }

      if (selectedOption) {
        setWarrantyOption(selectedOption);
      }
    }
  }, [showModal, options, warrantyOptionCurrent, isExtendedWarranty]);

  const handleWarrantySelect = (selectedOption) => {
    const markedOption = { ...selectedOption, selected: true };
    setWarrantyOption(markedOption);
  };

  const onSubmit = () => {
    if (warrantyOption) {
      const selectedWarrantyOption = { ...warrantyOption, selected: true };
      handleWarrantyChange(selectedWarrantyOption);
      if (!isExtendedWarranty) {
        trackWarrantySelection(
          'ModalPDP',
          _.get(product, 'currentVariant', ''),
          selectedWarrantyOption.name,
          selectedWarrantyOption.value || selectedWarrantyOption.variantId || selectedWarrantyOption.id
        );
      }
    } else if (isExtendedWarranty) {
      handleWarrantyChange(null);
    }
    if (!isExtendedWarranty) {
      setShowModal(false);
    }
  };

  const onSkip = () => {
    handleWarrantyChange(null);
  };

  const getContent = () => {
    const cancelText = isExtendedWarranty ? WITHOUT_EXTENDED_WARRANTY : CANCEL;
    const cancelAction = isExtendedWarranty ? onSkip : () => setShowModal(false);
    const acceptText = isExtendedWarranty ? 'Agregar protección' : ACCEPT_MKP;

    return (
      <>
        <WarrantySelectEnhanced
          appCtx={appCtx}
          options={options}
          warrantyOptionCurrent={warrantyOption}
          handleWarrantyOptionsSelected={handleWarrantySelect}
          product={product}
          source={isExtendedWarranty ? 'extended-modal' : ''}
        />
        <div className="sub-footer">
          <button type="button" className="cancel" onClick={cancelAction}>
            {cancelText}
          </button>
          <div className="submit">
            <Button type="mkp-secondary" onClick={onSubmit}>
              {acceptText}
            </Button>
          </div>
        </div>
        <style jsx>{WarrantyModalStyles}</style>
      </>
    );
  };

  if (isDesktop) {
    const modalOptions = {
      disableOutsideClick: true,
      padding: '24px',
      overflow: 'hidden',
      width: isExtendedWarranty ? 628 : 968,
      height: 'fit-content',
      borderRadius: '12px',
    };

    return (
      <Modal
        content={getContent}
        options={modalOptions}
        withPadding={false}
        toggleState={{
          visible: showModal,
          setVisible: setShowModal,
        }}
        showCloseButton={!isExtendedWarranty}
      />
    );
  }
  return (
    <Drawer toggleState={[showModal, setShowModal]} isLoading={false} type="secondary" icon="warranty-icon">
      <div className="drawer-content">
        {isExtendedWarranty && (
          <div className="header-mobile">
            <h2 className="title">{EXTENDED_WARRANTY_TITLE}</h2>
          </div>
        )}

        <WarrantySelectEnhanced
          appCtx={appCtx}
          options={options}
          warrantyOptionCurrent={warrantyOption}
          handleWarrantyOptionsSelected={handleWarrantySelect}
          product={product}
          source="drawer"
        />

        <div className="drawer-sub-footer">
          <div className="submit">
            <Button type="mkp-secondary" onClick={onSubmit}>
              {isExtendedWarranty ? 'Agregar protección' : ACCEPT_MKP}
            </Button>
          </div>
          <button type="button" className="cancel" onClick={isExtendedWarranty ? onSkip : () => setShowModal(false)}>
            {isExtendedWarranty ? WITHOUT_EXTENDED_WARRANTY : CANCEL}
          </button>
        </div>
        <style jsx>{WarrantyModalStyles}</style>
      </div>
    </Drawer>
  );
};

WarrantyModal.defaultProps = {
  showModal: false,
  setShowModal: noop,
  warrantyOptionCurrent: null,
  handleWarrantyChange: noop,
  options: [],
  appCtx: {},
  product: null,
  isExtendedWarranty: false,
};

WarrantyModal.propTypes = {
  warrantyOptionCurrent: PropTypes.object,
  showModal: PropTypes.bool,
  setShowModal: PropTypes.func,
  handleWarrantyChange: PropTypes.func,
  options: PropTypes.array,
  appCtx: PropTypes.object,
  product: PropTypes.object,
  isExtendedWarranty: PropTypes.bool,
};

export default WarrantyModal;
